import { getConfig } from '@klpkonsern/appconfig';
import { IconName } from '@klp/design/Illustrations';
import { generateRoute } from '@klp/routing';

import { SidebarMenuItem } from './classes/SidebarMenuItem';

// Extend AppConfigParameters for this module
declare global {
    interface AppConfigParameters {
        WEBAPP_IDENTITY_SERVER_URL: string;
        WEBAPP_APP_DEFAULT_LANGUAGE: string;
        WEBAPP_SAK_ENABLE: boolean;
    }
}

// Global helper functions for language/locale - since layout handles UI language
export const getDefaultLanguage = () =>
    getConfig('WEBAPP_APP_DEFAULT_LANGUAGE', 'no');

export const IdentityServerURL = () =>
    getConfig('WEBAPP_IDENTITY_SERVER_URL', '') + '?culture=';

export const SwedishErrorReportingModuleName = 'errorreporting';

export const SwedishErrorReportingRoutes = {
    moduleRoute: () => generateRoute([SwedishErrorReportingModuleName]),
    list: () => generateRoute([SwedishErrorReportingModuleName]),
};

const SakAccessDisabled = (): boolean => !getConfig('WEBAPP_SAK_ENABLE', false);

export const SwedishErrorReportingMenuItems = [
    new SidebarMenuItem({
        route: SwedishErrorReportingRoutes.list(),
        matchRoute: SwedishErrorReportingRoutes.moduleRoute(),
        icon: IconName.GEAR,
        translation: 'frontPage.errorReporting',
        access: SakAccessDisabled,
        callback: () =>
            window.open(
                'https://www.klpfastigheter.se/stockholm/hyresgastservice/felanmalan',
                '_blank',
            ),
    }),
];
